import type { Key, Selection } from "@ui/primitives/shared";

/** Unwrap a React Aria single `Selection` to its one string key (if any). */
export function firstSelectedKey(keys: Selection): string | undefined {
  if (keys === "all") return undefined;
  const key = [...keys][0];
  return typeof key === "string" ? key : undefined;
}

/** Unwrap a React Aria multiple `Selection` to a key array, resolving `"all"` via the caller's full key set. */
export function keysToArray(keys: Selection, all: () => Key[]): Key[] {
  return keys === "all" ? all() : [...keys];
}
